import React from 'react';
import { Box, Skeleton } from '@mui/material';

export function InfoSkeleton() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Skeleton variant="rounded" height={24} width="40%" sx={{ mb: 2 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        {[...Array(4)].map((_, i) => (
          <Box key={i}>
            <Skeleton variant="text" width="50%" sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="80%" />
          </Box>
        ))}
        <Box sx={{ gridColumn: '1 / -1' }}>
          <Skeleton variant="text" width="40%" sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="70%" />
        </Box>
      </Box>
    </Box>
  );
}

export function NotesSkeleton() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Skeleton variant="rounded" height={40} sx={{ mb: 2 }} />
      {[...Array(3)].map((_, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <Skeleton variant="rounded" height={80} />
        </Box>
      ))}
    </Box>
  );
}

export function PaymentsSkeleton() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Skeleton variant="rounded" height={40} sx={{ mb: 2 }} />
      {[...Array(3)].map((_, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <Skeleton variant="rounded" height={90} />
        </Box>
      ))}
    </Box>
  );
}

export function HistorySkeleton() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Skeleton variant="text" width="30%" sx={{ mb: 1.5 }} />
      {[...Array(2)].map((_, i) => (
        <Skeleton key={i} variant="rounded" height={80} sx={{ mb: 2 }} />
      ))}
      <Skeleton variant="text" width="35%" sx={{ mb: 1.5, mt: 1 }} />
      {[...Array(2)].map((_, i) => (
        <Skeleton key={i} variant="rounded" height={100} sx={{ mb: 2 }} />
      ))}
    </Box>
  );
}
